// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__23RCH","itemTitle":"ClientEmergencyInfo_itemTitle__1a6AV","itemText":"ClientEmergencyInfo_itemText__2_i0l"};